import { Outlet } from 'react-router-dom';
import { Page } from '@hopskipdrive/react-components';

import { useGetAuth } from '../../../auth/hooks/useAuthQuery';
import { PageLoader } from '../PageLoader';

import { PageInner } from './PageInner';

export const PageLayout = () => {
  const { data, isLoading } = useGetAuth();

  return !isLoading ? (
    <>
      {data ? (
        <div>
          <Page>
            <PageInner>
              <Outlet />
            </PageInner>
            <PageLoader />
          </Page>
        </div>
      ) : (
        <Outlet />
      )}
    </>
  ) : null;
};
